/// <reference path="./TranslationNotice.d.ts" />

/* global SITE_URL */
declare var SITE_URL: string;

import React from 'react';
import { FormattedMessage } from 'react-intl';

import logEvent from '~/util/analytics';

import StyledComponent from '~/components/Styled/Styled';
import css from './TranslationNotice.scss';

const trackEvent = (resourceUri: string) => {
  logEvent('click', { type: 'switch_to_english', resource_uri: resourceUri });
};

// tslint:disable-next-line:variable-name
const TranslationNotice = (props: Props) => {
  const { resourceUri } = props;

  return (
    <div className={css.bar}>
      <div className={`row ${css.container}`}>
        <span className={`col-xs-8 ${css.translatedByCopy}`}>
          <FormattedMessage id="translated_by.copy" defaultMessage="Translated by Google" />
        </span>
        <div className={`col-xs-4 ${css.englishBtn}`}>
          <a
            href={`${SITE_URL}${resourceUri}`}
            onClick={() => {
              trackEvent(resourceUri);
            }}
          >
            Switch to English
          </a>
        </div>
      </div>
    </div>
  );
};

TranslationNotice.displayName = 'TranslationNotice';

export default StyledComponent(TranslationNotice, [css]);
